import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'requestType' })
export class RequestTypePipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let result = null;
    switch (obj) {
      case 'CLIENT':
        result = '클라이언트신청';
        break;
      case 'IP':
        result = '아이피신청';
        break;
      case 'COMPANY':
        result = '그룹신청';
        break;
    }
    return result;
  }
}
